import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Tenía mi emprendimiento de ropa hace 2 años y casi nadie me compraba por internet. Apliqué el sistema del Tomo 3 y en la primera semana tuve 3 ventas por Instagram. El Script del Tomo 5 me cambió todo.',
  name: 'Valentina M.',
  location: 'Buenos Aires, Argentina',
  activity: 'Indumentaria'
}, {
  quote: 'Soy plomero y no tenía idea de cómo usar las redes para conseguir clientes. Con los prompts del Tomo 2 armé mi primer anuncio en 20 minutos y me empezaron a llegar consultas esa misma tarde.',
  name: 'Rodrigo F.',
  location: 'Córdoba, Argentina',
  activity: 'Servicios Técnicos'
}, {
  quote: 'Lo que más me sorprendió fue la Calculadora del Bono 3. Descubrí que estaba perdiendo plata con mis anuncios sin saberlo. La ajusté y ahora mi ROAS es 6x.',
  name: 'Luciana P.',
  location: 'Rosario, Santa Fe',
  activity: 'E-commerce'
}, {
  quote: 'Vendía por WhatsApp pero la gente siempre me dejaba en visto. Usé el Script Magnético y en una semana cerré 4 ventas que antes se me escapaban. Es una locura.',
  name: 'Diego A.',
  location: 'Mendoza, Argentina',
  activity: 'Venta de Insumos'
}, {
  quote: 'Nunca pensé que iba a poder hacer anuncios yo sola. Con la Hoja de Ruta del Bono 1 seguí el plan día por día y el día 6 cobré mi primera venta online.',
  name: 'Carolina S.',
  location: 'Tucumán, Argentina',
  activity: 'Coach / Servicios'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-20 px-4" data-id="element-239">
      <div className="max-w-5xl mx-auto" data-id="element-240">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-16" data-id="element-241">
          <span className="text-4xl mb-4 block" data-id="element-242">⭐</span>
          <h2 className="text-3xl sm:text-4xl font-black text-white drop-shadow-lg uppercase" data-id="element-243">
            LO QUE DICEN QUIENES YA LO ESTÁN APLICANDO
          </h2>
          <div className="w-24 h-1 bg-white/20 mx-auto mt-8" data-id="element-244"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-245">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-green-950/50 p-8 rounded-2xl border border-green-700/20 flex flex-col ${index === testimonials.length - 1 ? 'md:col-span-2 lg:col-span-1 md:w-1/2 md:mx-auto lg:w-full' : ''}`} data-id="element-246">
              <div className="flex gap-1 mb-4" data-id="element-247">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-248" />)}
              </div>
              <p className="text-white/90 font-medium italic mb-6 flex-grow leading-relaxed" data-id="element-249">
                "{testimonial.quote}"
              </p>
              <div className="mt-auto pt-4 border-t border-white/10" data-id="element-250">
                <p className="font-bold text-white" data-id="element-251">{testimonial.name}</p>
                <p className="text-xs text-yellow-300 font-bold uppercase mb-1" data-id="element-252">
                  {testimonial.activity}
                </p>
                <p className="text-xs text-white/60" data-id="element-253">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}